export type SupportedSearchEntity = 'customers' | 'products' | 'orders';

export const SEARCH_RELATIVE_PATH_BY_ENTITY: { [x in SupportedSearchEntity]: string | undefined } = {
    customers: '/commandCenter/workspaces/Edit/40da00fb-562b-48a5-80ba-c4d191e2fcd4?readOnly=true',
    orders: undefined,
    products: undefined
}